import type { FormEvent } from "react";

import { useI18n } from "~/i18n";
import { cn } from "~/lib/utils";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function MorrowTitleRoleForm({
  name,
  title,
  role,
  pending = false,
  actionsClassName,
  onNameChange,
  onTitleChange,
  onRoleChange,
  onSubmit,
}: {
  readonly name?: string;
  readonly title: string;
  readonly role: string;
  readonly pending?: boolean;
  readonly actionsClassName?: string;
  readonly onNameChange?: (value: string) => void;
  readonly onTitleChange: (value: string) => void;
  readonly onRoleChange: (value: string) => void;
  readonly onSubmit: () => void;
}) {
  const { t } = useI18n();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
      {onNameChange ? (
        <label className="flex min-w-0 flex-col gap-1.5">
          <span className="text-xs font-medium text-muted-foreground">{t("team.joinName")}</span>
          <Input
            value={name ?? ""}
            onChange={(event) => onNameChange(event.currentTarget.value)}
            placeholder={t("team.namePlaceholder")}
            required
          />
        </label>
      ) : null}
      <label className="flex min-w-0 flex-col gap-1.5">
        <span className="text-xs font-medium text-muted-foreground">{t("team.joinTitle")}</span>
        <Input
          value={title}
          onChange={(event) => onTitleChange(event.currentTarget.value)}
          placeholder={t("team.titlePlaceholder")}
        />
      </label>
      <label className="flex min-w-0 flex-col gap-1.5">
        <span className="text-xs font-medium text-muted-foreground">{t("team.joinRole")}</span>
        <Input
          value={role}
          onChange={(event) => onRoleChange(event.currentTarget.value)}
          placeholder={t("team.rolePlaceholder")}
        />
      </label>
      <div className={cn("flex", actionsClassName)}>
        <Button disabled={pending} size="sm" type="submit">
          {pending ? t("common.loading") : t("profile.team.save")}
        </Button>
      </div>
    </form>
  );
}
